"use strict";

var _classCallCheck = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _trelloSmoothDnd = require("trello-smooth-dnd");

var wrapperClass = _trelloSmoothDnd.constants.wrapperClass;

var Draggable = /*#__PURE__*/function (_react$Component) {
  _inherits(Draggable, _react$Component);

  var _super = _createSuper(Draggable);

  function Draggable() {
    _classCallCheck(this, Draggable);

    return _super.apply(this, arguments);
  }

  _createClass(Draggable, [{
    key: "render",
    value: function render() {
      if (this.props.render) {
        return _react.default.cloneElement(this.props.render(), {
          className: wrapperClass
        });
      }

      var clsName = "".concat(this.props.className ? this.props.className + ' ' : '');
      return _react.default.createElement("div", (0, _extends2.default)({}, this.props, {
        className: "".concat(clsName).concat(wrapperClass)
      }), this.props.children);
    }
  }]);

  return Draggable;
}(_react.Component);

Draggable.propTypes = {
  render: _propTypes.default.func
};
var _default = Draggable;
exports.default = _default;